import { Injectable } from '@angular/core';
import { CanMatch, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { AuthenticatorService } from 'idk/services/security/authenticator.service';
import { UserProfileService } from 'idk/services/security/user-profile.service';
import { Observable, of, switchMap } from 'rxjs';
import { RedirectionService } from '../services/redirection.service';

@Injectable({
    providedIn: 'root',
})
export class AuthenticatedGuard implements CanMatch {
    /**
     * Constructor
     */
    constructor(
        private _redirection: RedirectionService,
        private _authService: AuthenticatorService,
        private _profile: UserProfileService,
        private _router: Router
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Can match
     *
     * @param route
     * @param segments
     */
    canMatch(
        route: Route,
        segments: UrlSegment[]
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        return this._check(segments);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Check the authenticated status
     *
     * @param segments
     * @private
     */
    private _check(segments: UrlSegment[]): Observable<boolean | UrlTree> {
        const url = segments.join('/');

        // Check the authentication status
        return this._authService.check().pipe(
            switchMap((authenticated) => {
                // If the user is not authenticated...
                if (!authenticated) {
                    // Redirect to the sign-in page with a redirectUrl param
                    const redirectURL = `/${segments.join('/')}`;
                    this._redirection.url = redirectURL;
                    const urlTree = this._router.parseUrl('sign-in');

                    return of(urlTree);
                }

                if (
                    (
                        this._profile.user?.roles?.length > 1
                        ||
                        this._profile.user?.canBeImpersonated
                    )
                    &&
                        this._profile.role == null
                ) {
                    if (url == 'role-selection' || url == 'sign-in') {
                        return of(true);
                    }

                    const urlTree = this._router.parseUrl('role-selection');
                    return of(urlTree);
                }

                // Allow the access
                return of(true);
            })
        );
    }
}
